// @flow
import React, { Component } from 'react';
import { Button, Form, FormGroup, FormControl, Col, ControlLabel, Tabs, Tab } from 'react-bootstrap';

import MedicationInput from './components/MedicationInput/MedicationInput';
// import MedicationHistory from './components/MedicationHistory/MedicationHistory';

import locale from '../../../../locales/index';

class Medication extends Component<{
  user: Object,
}, {
  medication: Array<Object>,
  notificationEmail: string
}> {
  constructor(props: Object) {
    super(props);
    const settings = this.props.user.modules.agenda;
    this.state = {
      medication: settings.medications,
      notificationEmail: settings.notificationEmail,
    };
  }

  componentWillMount() {
    this.keys = this.state.medication.map((e, index) => (index.toString()));
  }


  onMedicationEmailChange(e: any) {
    this.setState({
      notificationEmail: e.target.value,
    });
  }

  addMedication() {
    const newList = this.state.medication;
    newList.push({ name: '', amount: '', days: [false, false, false, false, false, false, false], time: '13:00' });
    this.keys.push(((new Date()).getTime()).toString());
    this.setState({ medication: newList });
  }

  save(user: Object): Object {
    const newUser = user;
    const medications = this.state.medication.filter(e =>
      (e.name.length > 0) &&
      (e.amount.length > 0));

    newUser.modules.agenda.medications = medications;
    newUser.modules.agenda.notificationEmail = this.state.notificationEmail;
    return newUser;
  }

  remove(index: number) {
    const newList = this.state.medication;
    newList.splice(index, 1);
    this.keys.splice(index, 1);
    this.setState({ medication: newList });
  }

  medicationChanged(val: Object, index: number) {
    const newList = this.state.medication;
    newList[index] = val;
    this.setState({ medication: newList });
  }

  keys: Array<string>

  generateFields(): Array<Object> {
    return (this.state.medication.map((med, index) => (<MedicationInput
      medication={med}
      onRemove={() => this.remove(index)}
      key={this.keys[index]}
      onChange={e => this.medicationChanged(e, index)}
    />)));
  }

  render() {
    return (<div>
      <h4>{locale.medication}</h4>
      <div>
        <Tabs id="userMedications" defaultActiveKey={1}>
          <Tab eventKey={1} title={locale.settings}>
            <Form horizontal style={{ marginTop: '10px' }}>
              <FormGroup controlId="formHorizontalEmail">
                <Col componentClass={ControlLabel} sm={2}>
                  {locale.list}
                </Col>
                <Col sm={10}>
                  {this.generateFields()}
                  <span>
                    <Button onClick={() => this.addMedication()} bsStyle="primary">{locale.add}</Button>
                  </span>
                </Col>
              </FormGroup>
            </Form>
          </Tab>
          <Tab eventKey={2} title={locale.notifications} style={{ marginTop: '10px' }}>
            <Form horizontal>
              <FormGroup>
                <Col sm={4}><ControlLabel>{locale.medicationEmail}</ControlLabel></Col>
                <Col sm={8}>
                  <FormControl
                    defaultValue={this.props.user.modules.agenda.notificationEmail}
                    type="email"
                    placeholder={locale.medicationEmail}
                    onChange={e => this.onMedicationEmailChange(e)}
                  />
                </Col>
              </FormGroup>
            </Form>
          </Tab>
          <Tab eventKey={3} title={locale.history} style={{ marginTop: '10px' }}>
            History currently disabled
            {/* <MedicationHistory
              ownerId={this.props.user.id}
            /> */}
          </Tab>
        </Tabs>
      </div>
    </div>);
  }
}

export default Medication;



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/Medication/Medication.js